import Copy from "csi/table/Copy";
import declare from "dojo/_base/declare";
import SelectProductHierarchy from "../SiteAdmin/ProductHierarchy/SelectProductHierarchy";

const CopyFormulatedProduct = declare([Copy, SelectProductHierarchy], {
});

export = CopyFormulatedProduct;